import { render, staticRenderFns } from "./PendingBenefitApproval.vue?vue&type=template&id=7aff0210&scoped=true&"
import script from "./PendingBenefitApproval.vue?vue&type=script&lang=js&"
export * from "./PendingBenefitApproval.vue?vue&type=script&lang=js&"
import style0 from "./PendingBenefitApproval.vue?vue&type=style&index=0&id=7aff0210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aff0210",
  null
  
)

export default component.exports